'use client';

import { useSyncExternalStore } from 'react';
import { useReducedMotion } from '@/lib/use-reduced-motion';

const COARSE_POINTER_QUERY = '(pointer: coarse)';
const HOVER_NONE_QUERY = '(hover: none)';

function subscribeCoarse(onChange: () => void) {
  const mq = window.matchMedia(COARSE_POINTER_QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function getCoarseSnapshot() {
  return window.matchMedia(COARSE_POINTER_QUERY).matches;
}

function subscribeHoverNone(onChange: () => void) {
  const mq = window.matchMedia(HOVER_NONE_QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function getHoverNoneSnapshot() {
  return window.matchMedia(HOVER_NONE_QUERY).matches;
}

/**
 * Skip scroll reveals and use instant variants when motion should not gate visibility:
 * reduced motion, coarse pointer, or no hover (touch / tablet).
 */
export function useInstantMotion(): boolean {
  const prefersReducedMotion = useReducedMotion();
  const coarsePointer = useSyncExternalStore(subscribeCoarse, getCoarseSnapshot, () => false);
  const hoverNone = useSyncExternalStore(subscribeHoverNone, getHoverNoneSnapshot, () => false);

  return prefersReducedMotion || coarsePointer || hoverNone;
}
